import { useEffect } from "react";

import { Tracker } from "~utils/tracker";

const tracker = new Tracker({
    event: "Takeaways",
    action: "click",
});

const trackCarouselScrollButtons =
    (label: "click-fwd" | "click-back") => (_event: Event) => {
        tracker.trackEvent({
            category: "takeaways-nav",
            label,
        });
    };

const trackLeftButton = trackCarouselScrollButtons("click-back");
const trackRightButton = trackCarouselScrollButtons("click-fwd");

export function useGTMNavButtonsEffect({
    deps: [carouselRefState, isOpen],
}: {
    deps: [carouselRefState: HTMLDivElement | null, isOpen: boolean];
}) {
    useEffect(() => {
        if (carouselRefState && isOpen) {
            const previous = carouselRefState.querySelector(
                "[aria-label=Previous]"
            );
            const next = carouselRefState.querySelector("[aria-label=Next]");

            previous?.addEventListener("click", trackLeftButton);
            next?.addEventListener("click", trackRightButton);
            return () => {
                previous?.removeEventListener("click", trackLeftButton);
                next?.removeEventListener("click", trackRightButton);
            };
        }

        return () => {};
    }, [isOpen, carouselRefState]);
}
